import {Component} from '@angular/core';
import {CrudEdit} from '../../../../shared/components/crud-edit';
import {AbstractBffApi} from '../../../../models/sharedinterface';
import {UntypedFormBuilder} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiFactoryService} from '../../../../shared/services/api-factory.service';
import {CrudLanguagesService} from '../../../../shared/services/crud-languages.service';

@Component({
  selector: 'app-language-edit',
  templateUrl: './language-edit.component.html',
  styleUrls: ['./language-edit.component.scss']
})
export class LanguageEditComponent extends CrudEdit {
  private bffapi: AbstractBffApi;

  constructor(
    protected httpcrud: CrudLanguagesService, // Specific
    protected fb: UntypedFormBuilder,
    protected route: ActivatedRoute,
    protected router: Router,
    private apifactory: ApiFactoryService
  ) {
    super(httpcrud, fb, route, router);
    this.bffapi = this.apifactory.createBffApi();
  }

  initSpecificEditConfig() {
    // Specific
    this.entitylabelkey = 'label';
    this.redirecturl = '/admin/languages';

    this.entityformconfig = [
      {field: 'iso2', fieldlabel: 'iso2', fieldtype: 'text', required: true, maxlength: '2'},
      {field: 'browserKeys', fieldlabel: 'browserKeys', fieldtype: 'text', required: true, maxlength: '50'},
      {field: 'label', fieldlabel: 'label', fieldtype: 'text', required: true},
      {field: 'flagName', fieldlabel: 'flagName', fieldtype: 'text', required: true}
    ];
  } // initSpecificConfig

}
